module.exports = __webpack_public_path__ + "img/HC3P_Carrousel_9.144c088f.png";